import { AssetTag } from '@/types/rawModel';
import { Group, Stack, Text, StackProps, Autocomplete } from '@mantine/core';
import { AssetTagBadge } from '../atoms/AssetTagBadge';
import { CollapsibleSection } from '@/app/components/shared/viewer/CollapsibleSection';
import { useSelectedAsset } from '../../hooks/useAssetsQuery';
import { useSubmitQueryParameter } from '@/shared/useSubmitQueryParameter';
import { NewTag } from '../../components/upload/atoms/NewTag';

interface AssetTagsProps extends StackProps {
  onAddTag: (tag: string) => void;
  onDeleteTag: (tag: AssetTag) => void;
}

export function AssetTags({ onAddTag, onDeleteTag, ...props }: AssetTagsProps) {
  const selectedAsset = useSelectedAsset();
  const { submitSearch } = useSubmitQueryParameter('query', ['page']);

  const onTagClick = (name: string) => {
    submitSearch(name);
  };

  return (
    <CollapsibleSection title='Tags'>
      <Stack gap={8} {...props}>
        <Group gap='xs'>
          {selectedAsset?.tags?.map((t) => (
            <AssetTagBadge
              key={t.id}
              iconClick={() => {
                onDeleteTag(t);
              }}
              badgeClick={() => onTagClick(t.name)}
            >
              <Text fw={700}>{t.name}</Text>
            </AssetTagBadge>
          ))}
          <NewTag tags={selectedAsset?.tags?.map((tag) => tag.name)} onAddTag={onAddTag} />
        </Group>
      </Stack>
    </CollapsibleSection>
  );
}
